import React from 'react';
import Icon from '../../../components/AppIcon';

const BetaBanner = () => {
  return (
    <div
      className="w-full py-3 px-4 flex items-center justify-center gap-3 text-sm font-medium"
      style={{ background: 'linear-gradient(90deg, #1a1a2e 0%, #16213e 50%, #1a1a2e 100%)' }}
    >
      <div className="flex items-center gap-2 flex-shrink-0">
        <div className="w-5 h-5 rounded-full bg-amber-400/20 flex items-center justify-center">
          <Icon name="FlaskConical" size={12} color="#fbbf24" />
        </div>
        <span className="text-amber-400 font-semibold uppercase tracking-wider text-xs">Beta</span>
      </div>
      <span className="text-white/70 hidden sm:inline">|</span>
      <p className="text-white/80 text-center text-xs sm:text-sm">
        Stackd is currently in <span className="text-amber-400 font-semibold">closed beta testing</span>. Features are actively being developed and may change.{' '}
        <a href="#waitlist" className="text-white underline underline-offset-2 hover:text-amber-400 transition-colors duration-200">
          Register to stay informed →
        </a>
      </p>
    </div>
  );
};

export default BetaBanner;
